import { useContext } from 'react';
import * as R from 'ramda';

import ErrorSection from '@atom/components/common/moveElement/ErrorSection';

import ReplaceElementModalContext from './ReplaceElementModalContext';

import classes from './replaceElement.module.css';

const ErrorView = () => {
  const { element, replacementAsset, elementErrors } = useContext(
    ReplaceElementModalContext,
  );

  return (
    <div className={classes.errorView}>
      {R.keys(elementErrors).map(assetId => {
        const assetErrors = R.pathOr(
          [],
          [assetId, 'hasOtherAssets'],
          elementErrors,
        );

        const formErrors = R.pathOr(
          [],
          [assetId, 'hasFormAssets'],
          elementErrors,
        );

        const name =
          assetId === element?.id ? element?.name : replacementAsset?.name;

        return (
          <div>
            <div>
              <span className={classes.elementName}>{name}</span>
              <span>
                cannot be moved or replaced for the following reasons:
              </span>
            </div>
            <ErrorSection
              errors={assetErrors}
              message="This sub item shares open work with other sub items and/or current parent."
            />
            <ErrorSection
              errors={formErrors}
              message="This sub item is on open work that contains a form that allows editing other sub-items and/or current parent."
            />
          </div>
        );
      })}
    </div>
  );
};

export default ErrorView;
